module.exports = __webpack_public_path__ + "static/img/logo_white.a41b9a9b.png";